module.exports = {"141125100":"柳林镇","141125101":"穆村镇","141125102":"薛村镇","141125103":"庄上镇","141125104":"留誉镇","141125105":"三交镇","141125106":"成家庄镇","141125107":"孟门镇","141125200":"李家湾乡","141125201":"贾家垣乡","141125202":"陈家湾乡","141125203":"金家庄乡","141125204":"高家沟乡","141125205":"石西乡","141125206":"王家沟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141125.json
// module id = 341
// module chunks = 0